import $ from 'jquery';
import { ENDERECO_API } from '../../config/constant';
import { decode as rawBase64Decode, encode as base64_encode } from 'base-64';
import { showDuplicateLoginAlert } from '../../components/Auth/DuplicateLoginAlert';

const normalizeResgateXmlResponse = (value) => {
  if (typeof value !== 'string') {
    return value;
  }

  let normalizedValue = value.trim();

  if (normalizedValue.startsWith('"') && normalizedValue.endsWith('"')) {
    normalizedValue = JSON.parse(normalizedValue);
  }

  return normalizedValue;
};

const base64_decode = (value) => rawBase64Decode(normalizeResgateXmlResponse(value));

const isResgateXmlAuthError = (xhr) => {
  const candidates = [xhr?.message, xhr?.responseText, xhr?.responseJSON];

  return candidates.some((value) => {
    if (value === 'erro_auth') {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    let normalizedValue = value.trim();

    if (normalizedValue.startsWith('"') && normalizedValue.endsWith('"')) {
      normalizedValue = JSON.parse(normalizedValue);
    }

    try {
      normalizedValue = base64_decode(normalizedValue);
    } catch (err) {
      return normalizedValue === 'erro_auth';
    }

    return normalizedValue === 'erro_auth';
  });
};

const handleResgateXmlError = (xhr, reject, rejectMessage) => {
  if (isResgateXmlAuthError(xhr)) {
    showDuplicateLoginAlert();
  }
  reject([400, { message: rejectMessage }]);
};

const getSession = () => {
  const usersRt = sessionStorage.getItem('ddesp');
  return usersRt !== null ? JSON.parse(base64_decode(usersRt)) : null;
};

const ajaxResgateXmlEvent = ({
  type,
  ll,
  dd,
  tk,
  parseType = 'base64',
  rejectMessage = 'erro',
}) => new Promise(function (resolve, reject) {
  try {
    $.ajax({
      url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
      type,
      dataType: 'text',
      headers: {
        Authorization: 'Bearer ' + tk,
      },
      data: {
        pp: base64_encode('resgateXML'),
        ll: base64_encode(ll),
        dd,
      },
      success: function (data) {
        if (parseType === 'jsonBase64') {
          resolve([200, JSON.parse(base64_decode(data))]);
          return;
        }
        resolve([200, base64_decode(data)]);
      },
      error: function (xhr) {
        handleResgateXmlError(xhr, reject, rejectMessage);
      },
    });
  } catch (err) {
    reject([500, { message: err + ' Server Error' }]);
  }
});

const RestResgateXmlPost = (config) => {
  const Arr_ = JSON.parse(config.data);
  const caminho = Arr_.dest.trim();
  const storage = getSession();
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];

  switch (caminho) {
    case 'incluirChavesResgate': {
      const dd = base64_encode(JSON.stringify([base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.data))]));
      return ajaxResgateXmlEvent({ type: 'POST', ll: 'incluirChavesResgate', dd, tk: token });
    }
    case 'deletarChave': {
      const dd = base64_encode(JSON.stringify([base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.data))]));
      return ajaxResgateXmlEvent({ type: 'POST', ll: 'deletarChave', dd, tk: token });
    }
    case 'salvarAdicionais': {
      const dd = base64_encode(JSON.stringify([base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.data))]));
      return ajaxResgateXmlEvent({ type: 'POST', ll: 'salvarAdicionais', dd, tk: token });
    }
    case 'updateResgateEspionar': {
      const dd = base64_encode(JSON.stringify([base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.data))]));
      return ajaxResgateXmlEvent({ type: 'POST', ll: 'updateResgateEspionar', dd, tk: token });
    }
    case 'removerAdicionais': {
      const dd = base64_encode(JSON.stringify([base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.data))]));
      return ajaxResgateXmlEvent({ type: 'POST', ll: 'removerAdicionais', dd, tk: token });
    }
    case 'alterarLimiteDownload': {
      const dd = base64_encode(JSON.stringify([base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.data))]));
      return ajaxResgateXmlEvent({ type: 'POST', ll: 'alterarLimiteDownload', dd, tk: token });
    }
    case 'insereChaveHistorico': {
      const dd = base64_encode(JSON.stringify([base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))]));
      return ajaxResgateXmlEvent({ type: 'POST', ll: 'insereChaveHistorico', dd, tk: token });
    }
    case 'cadEmpresasGestao': {
      const dd = base64_encode(JSON.stringify([base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))]));
      return ajaxResgateXmlEvent({ type: 'POST', ll: 'cadEmpresasGestao', dd, tk: token });
    }
    case 'reenviarChavesRecusadas': {
      const dd = base64_encode(JSON.stringify([base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.data))]));
      return ajaxResgateXmlEvent({ type: 'POST', ll: 'reenviarChavesRecusadas', dd, tk: token });
    }
    case 'toggleNfceSPAutomatico': {
      const dd = base64_encode(JSON.stringify([base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.data))]));
      return ajaxResgateXmlEvent({ type: 'POST', ll: 'toggleNfceSPAutomatico', dd, tk: token });
    }
    case 'getSaldoResgate': {
      const dd = base64_encode(JSON.stringify([base64_encode(emp), base64_encode(uid)]));
      return ajaxResgateXmlEvent({ type: 'POST', ll: 'getSaldoResgate', dd, tk: token });
    }
    case 'resgateNfceSP': {
      const dd = base64_encode(JSON.stringify([base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.data))]));
      return ajaxResgateXmlEvent({ type: 'POST', ll: 'resgateNfceSP', dd, tk: token });
    }
    case 'desativarNfceSPAutomatico': {
      const dd = base64_encode(JSON.stringify([base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.data))]));
      return ajaxResgateXmlEvent({ type: 'POST', ll: 'desativarNfceSPAutomatico', dd, tk: token });
    }
    // data deve ser objeto ({ cnpj, chave } / { cnpj, chaves, ... }): listas de 1 item são "desembrulhadas" no espiaoCtrl
    case 'downloadXmlResgatado': {
      const dd = base64_encode(JSON.stringify([base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.data))]));
      return ajaxResgateXmlEvent({ type: 'POST', ll: 'downloadXmlResgatado', dd, tk: token });
    }
    case 'downloadLoteResgatados': {
      const dd = base64_encode(JSON.stringify([base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.data))]));
      return ajaxResgateXmlEvent({ type: 'POST', ll: 'downloadLoteResgatados', dd, tk: token });
    }
    default:
      return new Promise((resolve, reject) => reject([404, { message: 'Rota não encontrada' }]));
  }
};

const RestResgateXmlGet = (config) => {
  const caminho = config.dest.trim();
  const storage = getSession();
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];

  const ddFull = base64_encode(JSON.stringify([base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(config.dataPost))]));
  const ddBase = base64_encode(JSON.stringify([base64_encode(emp), base64_encode(uid)]));

  switch (caminho) {
    case 'getDataTableResgateXml':
      return ajaxResgateXmlEvent({ type: 'Get', ll: 'getDataTableResgateXml', dd: ddFull, tk: token });
    case 'getTotalResgatados': {
      const dd = base64_encode(JSON.stringify({ emp, uid, cnpj: config.cnpj }));
      return ajaxResgateXmlEvent({ type: 'Get', ll: 'getTotalResgatados', dd, tk: token });
    }
    case 'statusResgateEspionar': {
      const dd = base64_encode(JSON.stringify([base64_encode(emp), base64_encode(uid), base64_encode(config.cnpj)]));
      return ajaxResgateXmlEvent({ type: 'Get', ll: 'statusResgateEspionar', dd, tk: token });
    }
    case 'filterDataTableByDate':
      return ajaxResgateXmlEvent({ type: 'Get', ll: 'filterDataTableByDate', dd: ddFull, tk: token });
    case 'getStatusResgateEspionar':
      return ajaxResgateXmlEvent({ type: 'Get', ll: 'getStatusResgateEspionar', dd: ddFull, tk: token });
    case 'getAdicionaisResgate':
      return ajaxResgateXmlEvent({ type: 'Get', ll: 'getAdicionaisResgate', dd: ddFull, tk: token });
    case 'getHistoricoConsumo':
      return ajaxResgateXmlEvent({ type: 'Get', ll: 'getHistoricoConsumo', dd: ddBase, tk: token });
    case 'getLimiteDownload':
      return ajaxResgateXmlEvent({ type: 'Get', ll: 'getLimiteDownload', dd: ddBase, tk: token });
    case 'verificarTesteResgate':
      return ajaxResgateXmlEvent({ type: 'Get', ll: 'verificarTesteResgate', dd: ddBase, tk: token });
    case 'getUFs':
      return ajaxResgateXmlEvent({ type: 'Get', ll: 'getUFs', dd: ddBase, tk: token });
    case 'getEmpresas':
      return ajaxResgateXmlEvent({ type: 'Get', ll: 'getEmpresas', dd: ddBase, tk: token });
    case 'getConfigNfceSP':
      return ajaxResgateXmlEvent({ type: 'Get', ll: 'getConfigNfceSP', dd: ddFull, tk: token });
    default:
      return new Promise((resolve, reject) => reject([404, { message: 'Rota não encontrada' }]));
  }
};

export { RestResgateXmlPost, RestResgateXmlGet };